
<!--
 * @Description: 学生 详情 就业记录
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 12:01:19
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="就业单位" prop="sxdw" align="center" />
      <el-table-column label="就业岗位" prop="sxgw" align="center" />
      <el-table-column label="薪资" prop="xz" align="center" />
    </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无记录" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/shixi/shixijiouyejilu/list', data: tableData, parms: { xsid: props.row.id, order: 'jyrq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
p + p {
  margin-left: 10px;
}
span {
  font-weight: bold;
}
</style>
